import { render, staticRenderFns } from "./TextCredits.vue?vue&type=template&id=5b9ef46b&"
import script from "./TextCredits.vue?vue&type=script&lang=js&"
export * from "./TextCredits.vue?vue&type=script&lang=js&"
import style0 from "./TextCredits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports